import { render, staticRenderFns } from "./P17PrapaDebtReport.vue?vue&type=template&id=74cf3bec&"
import script from "./P17PrapaDebtReport.vue?vue&type=script&lang=js&"
export * from "./P17PrapaDebtReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports